export default "__VITE_ASSET__B1gskEpu__"